import { zodResolver } from "@hookform/resolvers/zod";
import { FC } from "react";
import { useForm } from "react-hook-form";
import { z } from "zod";

import { FileUploadInput } from "@/components/sku/file-upload-input";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader } from "@/components/ui/card";
import {
  Form,
  FormControl,
  FormDescription,
  FormField,
  FormItem,
  FormLabel,
} from "@/components/ui/form";
import { AddTrackButton } from "@/components/web-experience/audio-tab/add-track-button";

import { useAudioTabContext } from "./audio-tab-context";
import { AudioTracks } from "./audio-tracks";

const audioTabPlaylistFormSchema = z.object({
  cover_image_url: z.union([z.string().url(), z.literal("")]),
});

export const AudioTabPlaylist: FC = () => {
  const { options, data, onUpdateOptions } = useAudioTabContext();

  const form = useForm<z.infer<typeof audioTabPlaylistFormSchema>>({
    resolver: zodResolver(audioTabPlaylistFormSchema),
    defaultValues: { cover_image_url: options.cover_image_url ?? "" },
  });

  const onSubmit = (data: z.infer<typeof audioTabPlaylistFormSchema>) => {
    onUpdateOptions({
      ...options,
      cover_image_url: data.cover_image_url,
    });
  };

  return (
    <Card>
      <CardHeader>
        <h4 className="text-lg font-medium leading-none">Playlist</h4>
      </CardHeader>
      <Form {...form}>
        <form onSubmit={form.handleSubmit(onSubmit)}>
          <CardContent>
            <FormField
              control={form.control}
              name="cover_image_url"
              render={({ field }) => (
                <FormItem>
                  <FormLabel>Cover Image</FormLabel>
                  <FormControl>
                    <FileUploadInput {...field} fileType="image" />
                  </FormControl>
                  <FormDescription>
                    1:1 ratio recommended. Max 10,000 pixels.
                  </FormDescription>
                </FormItem>
              )}
            />

            <div className="space-y-4 mt-4">
              <p className="text-sm font-medium">Tracks</p>
              <AudioTracks tracks={data} />
              <AddTrackButton />
            </div>
          </CardContent>
          <div className="border-t px-6 py-4">
            <Button>Save</Button>
          </div>
        </form>
      </Form>
    </Card>
  );
};
